import { OpenNewTabTargetType } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import SharedPropsService from '../../SharedPropsService';
import { getContactNumberForWhatsapp } from '../../configs/uri-config-utils';
export const Done = async (action, _datastore, { goBack, openNewTab, instrumentTrack }) => {
    instrumentTrack('PHONEPE_OPEN_WA_BUTTON_CLICKED');
    const url = await SharedPropsService.getURL();
    const whatsappDeepLinkDesktop = await getContactNumberForWhatsapp(url);
    openNewTab('whatsapp://send?phone=+919611749097&text=Hi,%20I%20need%20Volt%20Money%20app%20link%20to%20complete%20my%20application', OpenNewTabTargetType.parent);
};
export const goBack = async (action, _datastore, { goBack, navigate, instrumentTrack }) => {
    instrumentTrack('PHONEPE_CONTACT_US_CLICKED');
    await navigate(ROUTE.CONTACT_US_CARD);
};
